import {Box} from '@mui/material';
import AurSelectDropdown from '../../../common/aur-select-dropdown/AurSelectDropdown';
import {Link} from 'react-router-dom';

const permissionGroups = [
  {id: 1, name: 'Reviewer'},
  {id: 2, name: 'Case Manager'},
  {id: 3, name: 'Contributer'},
];

const SelectDropdown = () => {
  return (
    <div style={{marginBottom: '64px'}}>
      <h1>Select Dropdown</h1>
      <Link to="/demo">Return</Link>
      <hr />
      <div style={{marginBottom: '32px'}}>
        <Box sx={{width: '400px'}}>
          <AurSelectDropdown
            items={permissionGroups}
            searchPlaceHolder="Search Projects"
            itemsCountwithNoScroll={3}
            defaultSelection={[]}
            itemDisplay="name"
            itemKey="id"
            selectAllLabel="Select All"
            dropdownLabel="Projects"
            onSelectionChange={(data) => {
              console.log(data);
            }}
            hasValidationError={false}
            validationText="Select atleast one Project"
            helperText="Select Project"
            aria-label="Project select dropdown"
          />
        </Box>
      </div>
    </div>
  );
};

export default SelectDropdown;
